import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/public-site/app/workshops/WorkshopsClient.tsx");
